import {useIsPipelinesSelected} from '../../../../../hooks/routes'
import {LINKS} from '../../Header.consts'
import HeaderLinkHost from '../LinkHost/LinkHost'
import styles from '../Links.css'

function PipelinesLink() {
  const pipelinesPartSelected = useIsPipelinesSelected()

  return (
    <div className={styles.container}>
      <HeaderLinkHost
        to={LINKS.pipelines}
        active={pipelinesPartSelected}
        className={styles.link}
        title={'Pipelines'}
      >
        {'Pipelines'}
      </HeaderLinkHost>
    </div>
  )
}

export default PipelinesLink
